import React from 'react';
import styled from 'styled-components/macro';
import modularScale from 'styles/helpers/modular-scale';
import TippyToolTip from 'components/base/TippyToolTip/TippyToolTip';

const StyledPositionArrow = styled('span')<any>`
  span {
    color: ${({ isPositive, theme }): string =>
      isPositive ? theme.PositiveChange : theme.NegativeChange};
  }
  display: inline-block;
`;

const Dash = styled('span')`
  color: ${({ theme }): string => theme.CasperGrey};
  font-size: ${modularScale(1)};
  line-height: 1em;
  display: inline-block;
  text-align: center;
  min-width: 11.6px;
`;

export const Bullet = styled('span')`
  width: 0.6em;
  height: 0.6em;
  display: inline-block;
  background: ${({ theme }): string => theme.PositiveChange};
  border-radius: 50%;
`;

const Placeholder = styled('span')`
  width: 0.6em;
  height: 0.6em;
  display: inline-block;
`;

interface IPositionArrowProps {
  position: number;
  previousPosition?: number;
  className?: string;
  withNumber?: boolean;
  isNewEntry?: boolean;
  showTooltip?: boolean;
  isVertical?: boolean;
  isAligned?: boolean;
}

const PositionArrow: React.FC<IPositionArrowProps> = ({
  position,
  previousPosition,
  className,
  withNumber,
  isNewEntry,
  showTooltip,
  isVertical,
  isAligned,
}) => {
  if (position && !previousPosition) {
    return <Dash className={className}>–</Dash>;
  }
  // Show nothing when the position isn't changed
  if (!position || !previousPosition) {
    return <Placeholder />;
  }

  if (isNewEntry) {
    return <Bullet className={className} />;
  }

  if (position === previousPosition) {
    return <Dash className={className}>–</Dash>;
  }

  const isPositive = position < previousPosition;
  const difference = previousPosition - position;
  const number = isPositive ? difference : Math.abs(difference);
  const tooltipContent = isPositive ? `+${number}` : `-${number}`;

  return (
    <StyledPositionArrow isPositive={isPositive} className={className}>
      <TippyToolTip
        disabled={!showTooltip && withNumber}
        delay={[0, 250]}
        interactive={false}
        tooltipContent={tooltipContent}
        canBeCopied
        isVertical={isVertical}
        isAligned={isAligned}
      >
        <span aria-hidden>{isPositive ? '▲' : '▼'}</span> {withNumber && number}
      </TippyToolTip>
    </StyledPositionArrow>
  );
};

export default PositionArrow;
